import { render, staticRenderFns } from "./VerticalNavbar.vue?vue&type=template&id=3d958395&scoped=true&"
import script from "./VerticalNavbar.vue?vue&type=script&lang=js&"
export * from "./VerticalNavbar.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavbar.vue?vue&type=style&index=0&id=3d958395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d958395",
  null
  
)

export default component.exports